<template>
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0" y="10" width="100" height="80" :style="styles"></rect>
    <circle cx="28" cy="45" r="20"></circle>
    <circle cx="72" cy="55" r="20"></circle>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'rgba(0,0,0,0.54)',
    },
  },
  computed: {
    styles() {
      return {
        fill: this.color,
      }
    },
  },
}
</script>

}

<style lang="scss" scoped>
$size: 24px;

svg {
  width: $size;
  height: $size;

  circle {
    fill: #fff;
  }
}
</style>
